import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AmplifyService from "services/AmplifyService";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  profile: {
    email: "",
    name: "",
    picture: "",
  },
};

export const getProfile = createAsyncThunk(
  "user/getProfile",
  async (data, { rejectWithValue }) => {
    try {
      const attributes = await AmplifyService.fetchAttributes();
      // console.log("getProfile response", attributes);
      const { email, name, picture } = attributes;

      let parsedPictureUrl = picture;
      try {
        // for fb picture
        const {
          data: { url },
        } = JSON.parse(picture);
        parsedPictureUrl = url;
      } catch (parseError) {
        // ignore just use original picture url
      }
      return { email, name, picture: parsedPictureUrl };
    } catch (err) {
      console.log("getProfile error", err);
      return rejectWithValue({ message: err.message || "Error" });
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(getProfile.rejected, (state, action) => {
        const { message } = action.payload;
        state.message = message;
        state.showMessage = true;
        state.loading = false;
      });
  },
});

export const {} = userSlice.actions;
export default userSlice.reducer;
